import moment from 'moment';

const FORMAT = 'YYYY-MM-DD';

// Периоды для оборотов кошелька. Остатки от периода не зависят.
export const WALLET_PERIODS = [
  { value: '7d', text: 'Последние 7 дней' },
  { value: '30d', text: 'Последние 30 дней' },
  { value: 'month', text: 'Текущий месяц' },
  { value: 'prev_month', text: 'Прошлый месяц' },
  { value: 'quarter', text: 'Текущий квартал' },
  { value: 'all', text: 'Всё время' },
];

export const DEFAULT_WALLET_PERIOD = '30d';

// Свой диапазон дат: только для таблицы остатков в карточке корпа (в остальных списках периодов его нет)
export const CUSTOM_PERIOD = 'custom';
export const BALANCE_PERIODS = [...WALLET_PERIODS, { value: CUSTOM_PERIOD, text: 'Свой диапазон' }];

export function defaultCustomRange() {
  return { from: moment().subtract(29, 'days').format(FORMAT), to: moment().format(FORMAT) };
}

export function walletPeriodRange(value, custom = null) {
  const today = moment();
  switch (value) {
    case CUSTOM_PERIOD: return custom && custom.from && custom.to ? { from: custom.from, to: custom.to } : defaultCustomRange();
    case 'month': return { from: today.clone().startOf('month').format(FORMAT), to: today.format(FORMAT) };
    case 'prev_month': {
      const prev = today.clone().subtract(1, 'month');
      return { from: prev.startOf('month').format(FORMAT), to: prev.clone().endOf('month').format(FORMAT) };
    }
    case 'quarter': return { from: today.clone().startOf('quarter').format(FORMAT), to: today.format(FORMAT) };
    case '7d': return { from: today.clone().subtract(6, 'days').format(FORMAT), to: today.format(FORMAT) };
    case 'all': return { from: null, to: null };
    default: return { from: today.clone().subtract(29, 'days').format(FORMAT), to: today.format(FORMAT) };
  }
}

export const PERIOD_HINT = 'Период влияет на движения. Остаток показан на текущий момент.';
